import React, { useState, useEffect } from "react"
import { AmountText, BootstrapInput, CustomInput, FullFormContainer, LabelContainer } from "./pay.styles"
import usePaymentInstallmentStore from "../../../store/payment/installments"
import { Alert, Button, CircularProgress, Grid, Typography, useTheme } from "@mui/material"
import { useForm } from "react-hook-form"
import { toast } from "react-toastify"
// import ModalLoading from "../../../../common/modal-loading"
import useCountDown from "react-countdown-hook"
import { onlyDigitsWithMaxLen } from "../../common/inputs/helper"
import PaymentInfo from "./paymentInfo"
import Head from "next/head"
import { useRouter } from "next/router"
import { useMediaQuery } from "react-responsive"
import ModalLoading from "../../common/modal-loading"
import TrackPayment from "./trackPayment"

function Payment() {
  const { getInquiryInstallmentPayment, installmentPaymentPin, installmentPayment } = usePaymentInstallmentStore()
  const [timeLeft, { start, pause, resume, reset: resetTimer }] = useCountDown(0, 100)
  const [getCode, setGetCode] = useState(false)
  const [loading, setLoading] = useState(false)

  /**
   * Consts and Variables
   * _______________________________________________________________________________
   */
  const {
    control,
    handleSubmit,
    register,
    reset,
    setFocus,
    getValues,
    watch,
    formState: { errors, isValid }
  } = useForm({})

  /**
   * States and Effects and Hooks
   * _______________________________________________________________________________
   */

  const [success, setSuccess] = useState(false)
  const [payment, setPayment] = useState(false)
  const [hiddenInput, setHiddenInput] = useState("")
  const [error, setError] = useState("")
  const [status, setStatus] = useState("done")
  const [detail, setDetail] = useState({})
  const [data, setData] = useState()
  const theme = useTheme()
  const router = useRouter()
  const isMobile = useMediaQuery({ maxWidth: 767 })

  useEffect(() => {
    setError("")
    setStatus("pending")
    getInquiryInstallmentPayment()
      .then(response => {
        if (response?.status === 200) {
          if (!response?.data?.succeed) {
            // toast.error(response?.data?.message || "خطایی پیش آمده است.")
            setError(response?.data?.message || "خطایی پیش آمده است.")
          } else {
            setStatus("done")
            setData(response?.data?.value)
          }
        }
      })
      .catch(() => {})
  }, [])

  /**
   * Methods
   * _______________________________________________________________________________
   */
  const handleInstallmentPayment = value => {
    setError("")
    const userDate = {
      installmentPaymentId: data.installmentPaymentId,
      cvv2: watch("cvv"),
      expirationMonth: watch("expirationMonth"),
      expirationYear: watch("expirationYear"),
      pin: watch("pin")
    }

    setPayment(true)

    installmentPayment(userDate)
      .then(response => {
        if (response?.status === 200) {
          if (!response?.data?.succeed) {
            //toast.error(response?.data?.message)
            setError(response?.data?.message)
            setPayment(false)
          } else {
            setActiveStep(2)
            setDetail({ payDate: response.data.value.payDate, trackingCode: response.data.value.trackingCode })
          }
        }
      })
      .catch(() => {})
  }

  const handleGetInstallmentPaymentPin = () => {
    setError("")
    setLoading(true)

    const userDate = {
      // mobileNumber: getValues("mobileNumber"),
      //installmentPaymentId: data.installmentPaymentId,
      amount: data.dueAmount,
      pan: hiddenInput
    }

    installmentPaymentPin(userDate)
      .then(response => {
        if (response?.status === 200) {
          if (!response?.data?.succeed) {
            //toast.error(response?.data?.message || "خطایی پیش آمده است.")
            setError(response?.data?.message || "خطایی پیش آمده است.")
            response?.data?.message(response?.data?.message || "خطایی پیش آمده است.")
          } else {
            setData({ ...data, installmentPaymentId: response.data.value.installmentPaymentId })
            setGetCode(true)
            start(90 * 1000)
            toast.success("رمز اینترنتی برای شما ارسال شد")
          }
        }
      })
      .catch(() => {})
      .finally(() => {
        setLoading(false)
      })
  }

  useEffect(() => {
    if (timeLeft === 0) {
      setGetCode(false)
    }
  }, [timeLeft])
  if (Object.keys(detail).length) {
    return <TrackPayment detail={detail} />
  } else {
    return (
      <div>
        {error && (
          <Alert severity='error' sx={{ borderRadius: 2, my: 2, width: "100%" }}>
            {error}
          </Alert>
        )}
        {!payment && !error ? (
          data ? (
            <Grid
              container
              md={12}
              xs={12}
              sx={{ marginTop: 2 }}
              component='form'
              onSubmit={handleSubmit(handleInstallmentPayment)}
            >
              <Grid item md={8} xs={12} sx={{ mb: 2 }}>
                <FullFormContainer>
                  <Typography variant='h5' mb={1.5}>
                    پرداخت اقساط
                  </Typography>

                  <Grid md={12} container gap={3}>
                    <LabelContainer item xs={12}>
                      <Grid className='container'>
                        <Typography className='title'>شماره کارت</Typography>
                        <Grid className='error-container'>
                          <CustomInput
                            name='pan'
                            id='cardNoRef'
                            autoComplete='off'
                            autoFocus
                            tabIndex={1}
                            onInput={event => {
                              let inputValue = event.currentTarget.value

                              // Remove any non-numeric characters and dashes
                              let numericPan = inputValue.replace(/[^0-9]/g, "")

                              // Limit the input to 16 characters (without dashes)
                              if (numericPan.length > 16) {
                                numericPan = numericPan.slice(0, 16)
                              }

                              // Format the PAN with dashes
                              let formatted = numericPan.match(/.{1,4}/g)?.join(" - ") || ""

                              // Set the formatted PAN in the input
                              event.currentTarget.value = formatted

                              // Update the hidden input
                              setHiddenInput(numericPan)
                              if (inputValue.length === 25) {
                                setFocus("cvv")
                              }
                            }}
                            type='tel' // Change the type to 'tel' for numeric input
                            {...register("pan", {
                              required: {
                                value: true,
                                message: "شماره کارت بانکی الزامی است"
                              },
                              validate: value => {
                                // Validate that the value has exactly 16 digits (no dashes)
                                return /^[0-9]{16}$/.test(value.replace(/[^0-9]/g, "")) || "شماره کارت باید 16 رقم باشد"
                              }
                            })}
                          />
                          {errors.pan && (
                            <Typography variant='caption' className='error'>
                              {errors.pan.message.toString()}
                            </Typography>
                          )}
                        </Grid>
                      </Grid>
                      <Typography className='caption' variant='body2'>
                        شماره کارت 16 رقمی درج شده روی کارت را وارد نمایید
                      </Typography>
                    </LabelContainer>

                    <LabelContainer item xs={12}>
                      <Grid className='container'>
                        <Typography className='title'>شماره شناسایی دوم (CVV2)</Typography>
                        <Grid className='error-container'>
                          <CustomInput
                            name='cvv'
                            tabIndex={3}
                            maxLength={4}
                            minLength={3}
                            onKeyDown={onlyDigitsWithMaxLen(4)}
                            type='password'
                            onInput={event => {
                              let inputValue = event.currentTarget.value
                              if (inputValue.length === 4) {
                                setFocus("expirationMonth")
                              }
                            }}
                            {...register("cvv", {
                              required: {
                                value: true,
                                message: "شماره 3 یا 4 رقمی درج شده روی کارت را وارد نمایید"
                              },
                              minLength: { value: 3, message: "شماره CCV2 باید 3 یا 4 رقم باشد" },
                              maxLength: { value: 4, message: "شماره CCV2 باید 3 یا 4 رقم باشد" }
                            })}
                          />
                          {errors.cvv && (
                            <Typography variant='caption' className='error'>
                              {errors.cvv.message.toString()}
                            </Typography>
                          )}
                        </Grid>
                      </Grid>
                      <Typography className='caption' variant='body2'>
                        شماره 3 یا 4 رقمی درج شده روی کارت را وارد نمایید
                      </Typography>
                    </LabelContainer>

                    <LabelContainer item xs={12}>
                      <Grid className='container'>
                        <Typography className='title'>تاریخ انقضای کارت</Typography>
                        <Grid className='date'>
                          <Grid className='error-container'>
                            <CustomInput
                              onKeyDown={onlyDigitsWithMaxLen(2)}
                              tabIndex={4}
                              placeholder='ماه'
                              inputMode='numeric'
                              type='text'
                              maxLength={2}
                              minLength={2}
                              onInput={event => {
                                let inputValue = event.currentTarget.value
                                if (inputValue.length === 2) {
                                  setFocus("expirationYear")
                                }
                              }}
                              name='expirationMonth'
                              {...register("expirationMonth", {
                                required: {
                                  value: true,
                                  message: "ماه الزامی است"
                                },
                                minLength: { value: 2, message: "ماه نامعتبر است" },
                                maxLength: { value: 2, message: "ماه نامعتبر است" },
                                min: { value: 1, message: "ماه نامعتبر است" },
                                max: { value: 12, message: "ماه نامعتبر است" }
                              })}
                            />
                            {errors.expirationMonth && (
                              <Typography variant='caption' className='error'>
                                {errors.expirationMonth.message.toString()}
                              </Typography>
                            )}
                          </Grid>
                          <Grid className='error-container'>
                            <CustomInput
                              onKeyDown={onlyDigitsWithMaxLen(2)}
                              inputMode='numeric'
                              type='text'
                              maxLength={2}
                              tabIndex={5}
                              placeholder='سال'
                              name='expirationYear'
                              {...register("expirationYear", {
                                required: {
                                  value: true,
                                  message: "سال الزامی است"
                                },
                                minLength: { value: 2, message: "سال نامعتبر است" },
                                maxLength: { value: 2, message: "سال نامعتبر است" },
                                min: { value: 1, message: "سال نامعتبر است" }
                              })}
                            />
                            {errors.expirationYear && (
                              <Typography variant='caption' className='error'>
                                {errors.expirationYear.message.toString()}
                              </Typography>
                            )}
                          </Grid>
                        </Grid>
                      </Grid>
                      <Typography className='caption' variant='body2'>
                        تاریخ انقضای کارت را وارد نمایید
                      </Typography>
                    </LabelContainer>

                    <LabelContainer item xs={12}>
                      <Grid className='container'>
                        <Typography className='title'>رمز اینترنتی کارت</Typography>
                        <Grid className='pass'>
                          <Grid className='error-container'>
                            <CustomInput
                              onKeyDown={onlyDigitsWithMaxLen(15)}
                              inputMode='numeric'
                              type='password'
                              tabIndex={6}
                              name='pin'
                              {...register("pin", {
                                required: {
                                  value: true,
                                  message: "رمز اینترنتی الزامی است"
                                }
                              })}
                            />
                            {/* 
                        <BootstrapInput
                          fullWidth
                          name='pin'
                          type='password'
                          tabIndex={6}
              
                          autoComplete='off'
                          {...register("pin", {
                            required: {
                              value: true,
                              message: "رمز اینترنتی الزامی است"
                            }
                          })}
                        /> */}
                            {errors.pin && (
                              <Typography variant='caption' className='error'>
                                {errors.pin.message.toString()}
                              </Typography>
                            )}
                          </Grid>

                          <Button
                            variant='contained'
                            size='large'
                            sx={{ borderRadius: "6px" }}
                            color='info'
                            className='button'
                            // onClick={() => (isValid ? setRequest("pin") : null)}
                            onClick={handleGetInstallmentPaymentPin}
                            disabled={
                              timeLeft > 0 ||
                              !watch("expirationYear") ||
                              !watch("expirationMonth") ||
                              !watch("cvv") ||
                              !watch("pan")
                            }
                          >
                            {timeLeft == 0 ? (
                              loading ? (
                                <CircularProgress size={10} color='inherit' />
                              ) : (
                                "دریافت رمز پویا"
                              )
                            ) : (
                              <Typography fontSize={"12px"} fontWeight={600}>
                                {String(Math.floor((timeLeft / 1000) % 60)).padStart(2, "0")} :{" "}
                                {String(Math.floor((timeLeft / 1000 / 60) << 0)).padStart(2, "0")}
                              </Typography>
                            )}
                          </Button>
                        </Grid>
                      </Grid>
                      <Typography className='caption' variant='body2'>
                        رمز اینترنتی را وارد نمایید
                      </Typography>
                    </LabelContainer>

                    <Grid sx={{ width: "100%", textAlign: "center" }}>
                      <Typography variant='subtitle1'>مبلغ قابل پرداخت:</Typography>
                      <AmountText className='amount' sx={{ mt: 1.3, color: theme.palette.primary.main }}>
                        {Number(data?.dueAmount).toLocaleString()}
                      </AmountText>
                      <Typography variant='subtitle1' sx={{ color: theme.palette.primary.main }}>
                        ریال
                      </Typography>
                    </Grid>

                    <Grid container xs={12} md={12}>
                      <Grid item md={7} xs={12}>
                        <Button type='submit' fullWidth variant='contained' color='success'>
                          پرداخت
                        </Button>
                      </Grid>

                      {/* <Grid item md={5} xs={12} sx={{ textAlign: "center", px: 2, pt: isMobile ? 2 : 0 }}>
                      <Button
                        onClick={() => {
                          setActiveStep(0)
                        }}
                        variant='contained'
                        color='info'
                        sx={{ mx: 1 }}
                      >
                        تغییر مبلغ
                      </Button>
                      <Button
                        onClick={() => {
                          setActiveStep(0)
                          router.push("/main/transactions")
                        }}
                        variant='contained'
                        color='error'
                      >
                        انصراف
                      </Button>
                    </Grid> */}
                    </Grid>
                  </Grid>
                </FullFormContainer>
              </Grid>
              <Grid item md={4} xs={12} sx={{ bgcolor: "#f9f9f9", mb: 2 }}>
                <PaymentInfo data={data} />
              </Grid>
            </Grid>
          ) : (
            <ModalLoading open={true} />
          )
        ) : status === "loading" ? (
          <ModalLoading open={true} />
        ) : null}
      </div>
    )
  }
}

export default Payment
